import { required, staticMsg } from 'src/utils/constants';

export const arrayToTree = (data) => {
    let choices = [];
    let rootArr = [];
    let i = 0;
    data.forEach(a => {
        choices.push(...a.choices);
    })

    const handleQuestions = (qs) => {
        let ind = choices.find(a => a.follow_up_id === qs._id);
        let children = [];
        qs.choices.forEach(a => {
            children.push(handleChoices(a))
        })

        let obj = {
            id: qs._id,
            title: qs.question,
            type: 'question',
            parentId: ind ? ind._id : null,
            children,
            index: i++
        }
        if(!ind){
            rootArr.push(obj);
        }
        return obj
    }

    const handleChoices = (ch) => {


        let children = [];
        if(ch.hasFollowup){
            let qs = data.find(a => a._id === ch.follow_up_id);
            children.push(handleQuestions(qs))
        }



        let obj = {
            id: ch._id,
            title: ch.label,
            type: 'choice',
            parentId: ch.question_id,
            children,
            index: i++
        }


        return obj
    }


    data.forEach(a => {
        handleQuestions(a);
    })

    console.log(rootArr)

    return rootArr
}


export const validateApplication = (data) => {
    let errors = {};
    if(data && data.length !== 0){
       
        data.forEach(a => {
            let isErr = Object.keys(errors).length === 0 ? true : false;
            if(!a.isPass && isErr){
            let rf = required.find(ab => ab.id === a.id);
            errors = {...rf, type: 'error'}
            }
        })
    }
    return {
        errors,
        valid: Object.keys(errors).length === 0 ? true : false
      };

}

export const validateLoans = (data) => {
    let errors = {};
    if(data && data.length !== 0){
        data.forEach(a => {
            if(a.status === 'unpaid'){
                errors = {
                    message: staticMsg.unpaidLoan(a),
                    type: 'error'
                }
            }
            if(a.status === 'review'){
                errors = {
                    message: staticMsg.reviewLoan(a),
                    type: 'error'
                }
            }
          
        })
    }
    return {
        errors,
        valid: Object.keys(errors).length === 0 ? true : false
      };

}